import React, { useEffect, useState, useMemo, useCallback } from 'react';
import block from 'bem-cn';
import { useSelector, useDispatch, shallowEqual } from 'react-redux';
// import SVGInline from 'react-svg-inline';
import { Link } from 'react-router-dom';

import { actions as usersActions } from 'features/users/redux';

import InputSearch from 'components/InputSearch';
// import Input from 'components/Input';
import BackBlock from 'components/BackBlock';
// import Spinner from 'components/Spinner';
// import Button from 'components/Button';
import SVG from 'components/SVG';

import arrowSvg from './img/arrow.svg';

import './UsersList.scss';

const b = block('users-list');

const sortByValues = [{value: null, active: false},{value: 'asc', active: false},{value: 'desc', active: false},]

const UsersList = () => {
  const [filterValue, onChangeFilterValue] = useState('');
  const [sortBy, setSortBy] = useState(sortByValues)
  const [isSortByOpen, setSortByOpen] = useState(false);
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(usersActions.getUsersList(sortActiveValue));
  }, [dispatch, sortBy]);

  const changeFilterValue = useCallback(e => {
    onChangeFilterValue(e.currentTarget.value);
  }, []);

  const locale = useSelector(state => state.locale.locale, shallowEqual);
  const usersList = useSelector(state => state.users.usersList, shallowEqual);

  const list = useMemo(
    () =>
      usersList.users
        ?.filter(t => ~t.nickname?.toUpperCase().indexOf(filterValue.toUpperCase()) || false)
        .map(item => (
          <Link key={item.id} className={b('item')} to={`/user-edit/${item.id}`}>
            <div className={b('item-text')}>{`${item.nickname} (ID: ${item.id})`}</div>
            <div className={b('item-balance')}>{item.balance}</div>
            <SVG svgProps={{ svg: arrowSvg }} className={b('item-arrow')} />
          </Link>
        )) || [],
    [filterValue, usersList],
  );

  const sortActiveValue = sortBy.find(item => item.active)?.value ?? null;
  
  const handleSortClick = (value) => {
    setSortBy(prev =>
      prev.map(item => ({
        ...item,
        active: item.value === value,
      })),
    );
    setSortByOpen(false);
  };
  
  return (
    <div className={b()}>
      <div className={b('back-block')}>
        <BackBlock>{locale.userCardBalances}</BackBlock>
      </div>
      <div className={b('search')}>
        <div className={b('search-input')}>
          <InputSearch value={filterValue} onChange={changeFilterValue} placeholder={locale.typeSomething} />
        </div>
      </div>
      <div className={b('subheader')}>
      <div className={b('subheader-data')}>
        <div className={b('subheader-data-item')}>
          <div className={b('subheader-data-item-nick')}>{locale.userCard}</div>
          <div className={b('subheader-data-item-value')}>{usersList.quantity}</div>
        </div>
        <div className={b('subheader-data-item')}>
          <div className={b('subheader-data-item-nick')}>{locale.accountBalance}</div>
          <div className={b('subheader-data-item-value')}>{usersList.totalBalance}</div>
        </div>
      </div>
     
          <div onClick={() => setSortByOpen(!isSortByOpen)} className={b('sort')}>
            <div className={b('sort-title')}>{locale.sortBy}:</div>
            <div className={b('sort-container')}>
              <div className={b('sort-type')}>{ locale.sortByTitles[sortActiveValue]}</div>
              <SVG className={b('sort-arrow', {opened: isSortByOpen})} svgProps={{svg: arrowSvg}} />
              {isSortByOpen && 
        (
              <div className={b('sort-items')}>{sortBy.map(item => 
                <div       key={String(item.value)}
                onClick={() => handleSortClick(item.value)} className={b('sort-item', {active: item.value === sortActiveValue})}>
                  {locale.sortByTitles[item.value]}</div>)}
                </div>
                )
              }
            </div>
          </div>
        
      </div>
      <div className={b('list')}>{list}</div>
    </div>
  );
};

export default UsersList;
